export function secondsToMilliseconds(seconds: number): number {
  return 1000 * seconds
}
